// @ts-nocheck
import { ACTIONS } from "@/_config";
import { PromotionalBlock } from "@/_types/cms";

interface CmsState {
  blocks: PromotionalBlock[];
}

const initialState: CmsState = {
  blocks: [],
};

const cmsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default cmsReducer;
